import * as _ from "lodash-es";
import React, { Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGenerateAccountingExcelFileDTO from "../../../models/DTO/IGenerateAccountingExcelFileDTO";
import IGetAccountingDTO from "../../../models/DTO/IGetAccountingDTO";
import IOnGenerateAccountingExcelFileDTO from "../../../models/DTO/IOnGenerateAccountingExcelFileDTO";
import IOnGetAccountingDTO from "../../../models/DTO/IOnGetAccountingDTO";
import IOnQBDCreateDTO from "../../../models/DTO/IOnQBDCreateDTO";
import IQBDCreateDTO from "../../../models/DTO/IQBDCreateDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IAccounting from "../../../models/IAccounting";
import IAction from "../../../models/IAction";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ICheckBoxCheckedAccounting from "../../../models/ICheckBoxCheckedAccounting";
import INotification from "../../../models/INotification";
import IOwTableCols from "../../../models/IOwTableCols";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import QBDResourceTypesEnum from "../../../models/QBDResourceTypesEnum";
import UserService from "../../../services/UserService";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwActionBar from "../../shared/OwActionBar/OwActionBar";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import AccountingSidebar from "../AccountingSidebar/AccountingSidebar";
import { Socket } from "socket.io-client";
import IQBDGetXmlDTO from "../../../models/DTO/IQBDGetXmlDTO";
import IQBDOnGetXmlDTO from "../../../models/DTO/IQBDOnGetXmlDTO";
import IQBOCreateGroupedInvoiceDTO from "../../../models/DTO/IQBOCreateGroupedInvoiceDTO";
import IQBOOnCreateGroupedInvoiceDTO from "../../../models/DTO/IQBOOnCreateGroupedInvoiceDTO";
import { QBOInvoiceActions } from "../../shared/QBOInvoiceActions/QBOInvoiceActions";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import IQBOGetPDFInvoiceDTO from "../../../models/DTO/IQBOGetPDFInvoiceDTO";
import IQBODeleteInvoiceDTO from "../../../models/DTO/IQBODeleteInvoiceDTO";
import PdfSidebarViewer from "../../shared/PdfSidebarViewer/PdfSidebarViewer";
import IQBOOnGetPDFInvoiceDTO from "../../../models/DTO/IQBOOnGetPDFInvoiceDTO";
import IQBOOnDownloadJsonDTO from "../../../models/QuickBooks Online/IQBOOnDownloadJsonDTO";
import IQBODownloadJsonDTO from "../../../models/QuickBooks Online/IQBODownloadJsonDTO";
import { AccountingOrdersCol } from "./AccountingOrdersCol/AccountingOrdersCol";
import { AccountingActionsCol } from "./AccountingActionsCol/AccountingActionsCol";
import { ClickToCopy } from "../../shared/ClickToCopy/ClickToCopy";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import UIService from "../../../services/UIService";
import { SearchSection } from "../../shared/SearchSection/SearchSection";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
};

type State = {
    breadcrumbs: IBreadcrumbs[];
    columns: IOwTableCols[];
    accountingRows: IAccounting[];
    totalRows: number;
    limit: number;
    offset: number;
    isDataFetching: boolean;
    isInitialData: boolean;
    checkBoxChecked: ICheckBoxCheckedAccounting[];
    numCheckBoxChecked: number;
    hasAllChecked: boolean;
    hasOneChecked: boolean;
    createQbdInvoiceActive: boolean;
    createQboInvoiceActive: boolean;
    showHiddenFeatures: boolean;
    actions: IAction[];
    name?: string;
};

export default class Accounting extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        const actions: IAction[] = [];

        if (this.props.supplierModel.Supplier_Integration.has_qbo && this.props.supplierModel.Supplier_Integration.qbo_grouped_invoices) {
            actions.push({
                name: "quickbooks_online",
                isGroup: true,
                groupActions: [
                    {
                        fn: this.createGroupedInvoice,
                        name: "create_grouped_invoice",
                        leftIconClass: "fas fa-plus",
                        disabledFn: () => {
                            return !this.state.hasOneChecked;
                        },
                        isActive: () => {
                            return this.state.createQboInvoiceActive;
                        },
                    },
                ],
            });
        }

        if (
            this.props.supplierModel.Supplier_Integration.has_qbd &&
            this.props.supplierModel.Supplier_Integration.qbd_has_grouped_invoice
        ) {
            actions.push({
                name: "quickbooks_desktop",
                isGroup: true,
                groupActions: [
                    {
                        fn: this.addGroupedInvoices,
                        name: "create_grouped_invoice",
                        leftIconClass: "fas fa-plus",
                        disabledFn: () => {
                            return !this.state.hasOneChecked;
                        },
                        isActive: () => {
                            return this.state.createQbdInvoiceActive;
                        },
                    },
                    {
                        fn: this.getXml,
                        name: "get_xml",
                        leftIconClass: "",
                        disabledFn: () => {
                            return !this.state.hasOneChecked;
                        },
                        isActive: () => {
                            return this.state.createQbdInvoiceActive;
                        },
                        btnClass: () => {
                            return this.state.showHiddenFeatures ? "btn-primary" : "d-none";
                        },
                    },
                ],
            });
        }

        const columns: IOwTableCols[] = [
            {
                hasCheckAll: true,
                isActionsCol: true,
                title: "",
                valueProp: "",
                renderFn: this.renderInfoFn,
                renderFnEmitsRow: true,
            },
            {
                title: "no",
                valueProp: "name",
            },
            {
                title: "vendor",
                valueProp: "vendor",
                titleRenderFn: this.renderVendorTitle,
                renderFn: this.renderVendors,
                renderFnEmitsRow: true,
            },
            {
                title: "orders",
                valueProp: "orders",
                renderFn: this.renderOrders,
                renderFnEmitsRow: true,
            },
            {
                title: "created_at",
                valueProp: "created_at",
                renderFn: this.renderDate,
                renderFnEmitsRow: true,
            },
        ];

        if (
            this.props.supplierModel.Supplier_Integration.has_qbd &&
            this.props.supplierModel.Supplier_Integration.qbd_has_grouped_invoice
        ) {
            columns.push({
                title: "invoice_top_line",
                valueProp: "qbd_invoice_top_line",
            });
        }

        columns.push({
            title: "actions",
            valueProp: "",
            renderFn: this.renderActionButtons,
            renderFnEmitsRow: true,
        });

        this.state = {
            breadcrumbs: [
                { title: "Dashboard", url: "/dashboard" },
                { title: "Accounting", url: "/accounting" },
            ],
            columns,
            accountingRows: [],
            isDataFetching: true,
            isInitialData: true,
            totalRows: 0,
            offset: 0,
            limit: 10,
            hasOneChecked: false,
            numCheckBoxChecked: 0,
            checkBoxChecked: [],
            actions,
            createQbdInvoiceActive: false,
            hasAllChecked: false,
            showHiddenFeatures: false,
            createQboInvoiceActive: false,
        };

        this.sockets = [
            { endpoint: EndpointsEnum.AccountingOnGetAccounting, fn: this.onGetAccounting },
            { endpoint: EndpointsEnum.AccountingOnGenerateExcelFile, fn: this.onGenerateExcelFile },
            { endpoint: EndpointsEnum.QBDOnCreate, fn: this.onQBDCreate },
            { endpoint: EndpointsEnum.QBDOnGetXML, fn: this.onGetXml },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.QBOOnCreateGroupedInvoice, fn: this.onCreateGroupedInvoice },
            { endpoint: EndpointsEnum.QBOOnGetPDFInvoice, fn: this.onGetQboPdfInvoice },
            { endpoint: EndpointsEnum.QBOOnDeleteInvoice, fn: this.onDeleteQboInvoice },
            { endpoint: EndpointsEnum.QBOOnDownloadJson, fn: this.onDownloadJson },
        ];

        document.title = `Orderwerks >> Accounting`;
    }

    componentDidMount(): void {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        this.getAccounting();
    }

    componentWillUnmount(): void {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (!this.state.showHiddenFeatures) {
            // @ts-expect-error
            if (!_.isNil(window.showHiddenFeatures)) {
                this.setState({
                    showHiddenFeatures: true,
                });
            }
        }
    }

    notify = () => {
        this.setState({
            createQbdInvoiceActive: false,
        });
    };

    getXml = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const accountingGuid = _.map(checkedOrders, (detail) => {
            return detail.accounting.guid;
        });

        if (accountingGuid.length === 1) {
            const payload: IQBDGetXmlDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                type: "GROUPED_INVOICE",
                typeGuid: accountingGuid[0],
            };

            this.props.socket.emit(EndpointsEnum.QBDGetXML, payload);

            this.setState({
                createQbdInvoiceActive: true,
            });
        }
    };

    onGetXml = (data: IQBDOnGetXmlDTO) => {
        const blob = new Blob([data.xmlData], { type: "application/xml" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.download = "Accounting Grouped Invoice XML Data.xml";
        link.click();

        this.setState({
            createQbdInvoiceActive: false,
        });
    };

    downloadJson = (row: IAccounting) => {
        const payload: IQBODownloadJsonDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            type: "GROUPED_INVOICE",
            typeGuid: row.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBODownloadJson, payload);
    };

    onDownloadJson = (data: IQBOOnDownloadJsonDTO) => {
        console.log(JSON.parse(data.data));
    };

    checkAll = (checkAll: boolean) => {
        const checkBoxChecked = this.state.checkBoxChecked;

        let hasOneChecked = false;
        let numCheckBoxChecked = 0;

        for (const checkBox of checkBoxChecked) {
            checkBox.checked = checkAll;

            if (checkAll) {
                numCheckBoxChecked++;
                hasOneChecked = true;
            }
        }

        this.setState({
            checkBoxChecked,
            hasAllChecked: checkAll,
            hasOneChecked,
            numCheckBoxChecked,
        });
    };

    onQBDCreate = (data: IOnQBDCreateDTO) => {
        const notification: INotification = {
            message: "successfully_queued_grouped_invoice",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            createQbdInvoiceActive: false,
        });
    };

    getCheckedOrdersArr = (): {
        guid: string;
        name: string;
        qbd_TxnID?: string;
        order_batch_id?: number | null;
        accounting: IAccounting;
    }[] => {
        const checkedCheckBoxes = this.state.checkBoxChecked;

        const checkedAccounting = _.filter(checkedCheckBoxes, (checkBox) => {
            return checkBox.checked;
        });

        return _.map(checkedAccounting, (row) => {
            const accountingDetail: any = { guid: row.accountingGuid, name: row.name, accounting: row.accounting };

            // if (this.state.showQbdActions) {
            //     // console.log("order.qbd_TxnID", order.qbd_TxnID, order);
            //     orderDetail.qbd_TxnID = order.qbd_TxnID;
            // }

            return accountingDetail;
        });
    };

    createGroupedInvoice = () => {
        if (this.props.userModel) {
            const checkedAccountingArr = this.getCheckedOrdersArr();

            const payload: IQBOCreateGroupedInvoiceDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel!.guid,
                accountingGuid: checkedAccountingArr[0].guid,
            };

            this.props.socket.emit(EndpointsEnum.QBOCreateGroupedInvoice, payload);
        }
    };

    onCreateGroupedInvoice = (data: IQBOOnCreateGroupedInvoiceDTO) => {
        const notification: INotification = {
            message: "successfully_created_grouped_invoice",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.getAccounting();
    };

    onDeleteQboInvoice = () => {
        this.getAccounting();
    };

    addGroupedInvoices = () => {
        if (this.props.userModel) {
            const checkedOrders = this.getCheckedOrdersArr();

            const orderGuids = _.map(checkedOrders, (order: any) => {
                return order.guid;
            });

            const payload: IQBDCreateDTO = {
                resource: QBDResourceTypesEnum.INVOICE,
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel!.guid,
                orderGuids,
            };

            this.props.socket.emit(EndpointsEnum.QBDCreate, payload);

            this.setState({
                createQbdInvoiceActive: true,
            });
        }
    };

    toggleCheckBox = (data: IAccounting, index: number) => {
        const currentCheckBoxChecked = this.state.checkBoxChecked;

        currentCheckBoxChecked[index].checked = !currentCheckBoxChecked[index].checked;

        const elem = document.getElementById(`row-${index}`);

        if (currentCheckBoxChecked[index].checked) {
            elem!.classList.add("highlight-row");
        } else {
            elem!.classList.remove("highlight-row");
        }

        let numCheckBoxChecked = 0;

        _.each(currentCheckBoxChecked, (checkBoxDetail) => {
            if (checkBoxDetail.checked) {
                numCheckBoxChecked++;
            }
        });

        const hasOneCheckedItem = _.find(currentCheckBoxChecked, (checkBoxDetail) => {
            return checkBoxDetail.checked;
        });

        const hasOneChecked = _.get(hasOneCheckedItem, "checked", false);

        this.setState({
            hasOneChecked,
            numCheckBoxChecked,
            checkBoxChecked: currentCheckBoxChecked,
        });
    };

    editAccounting = (row: IAccounting) => {
        const component = (
            <AccountingSidebar
                accounting={row}
                setActivityIndicator={this.props.setActivityIndicator}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                notifyFn={this.props.notifyFn}
                socket={this.props.socket}
                cancelFn={this.cancelSidebar}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    cancelSidebar = (refreshData?: boolean) => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);

        if (refreshData) {
            this.getAccounting();
        }
    };

    renderInfoFn = (row: IAccounting, index: number) => {
        let isChecked = false;

        if (this.state.checkBoxChecked && this.state.checkBoxChecked[index]) {
            isChecked = this.state.checkBoxChecked[index].checked;
        }

        if (
            (this.props.supplierModel.Supplier_Integration.has_qbd &&
                this.props.supplierModel.Supplier_Integration.qbd_has_grouped_invoice) ||
            this.props.supplierModel.Supplier_Integration.qbo_grouped_invoices
        ) {
            return (
                <div className={"no-wrap"}>
                    <OwCheckbox
                        checked={isChecked}
                        className={"me-4 d-print-none pointer"}
                        label={""}
                        skipTranslate={true}
                        name={""}
                        fn={() => {
                            this.toggleCheckBox(row, index);
                        }}
                    />
                    <OwButton
                        centerIconClass={"fad fa-pencil"}
                        fn={() => {
                            this.editAccounting(row);
                        }}
                    />
                    <i
                        className={
                            "ms-2 fad fa-file-invoice " + (row.qbd_Invoice_TxnID || row.qbo_invoice_id ? "text-success" : "text-muted")
                        }
                    />
                    {this.state.showHiddenFeatures ? (
                        <div>
                            <ClickToCopy as={"div"} text={row.guid} noFlexGrow={true} />
                        </div>
                    ) : null}
                </div>
            );
        } else {
            return null;
        }
    };

    downloadExcel = (row: IAccounting) => {
        const payload: IGenerateAccountingExcelFileDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            accountingGuid: row.guid,
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit(EndpointsEnum.AccountingGenerateExcelFile, payload);
    };

    onGenerateExcelFile = (data: IOnGenerateAccountingExcelFileDTO) => {
        const blob = new Blob([data.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.download = data.filename;
        link.click();
    };

    renderVendorTitle = (col: IOwTableCols) => {
        return <OwLabel title={"vendor"} isSupplierVendorOverride={true} supplierModel={this.props.supplierModel} />;
    };

    renderVendors = (row: IAccounting) => {
        const vendorsUnique = new Set();

        for (const order of row.Orders || []) {
            if (order.Vendor) {
                vendorsUnique.add(order.Vendor?.name);
            }
        }

        const uniqueVendors = Array.from(vendorsUnique).join(", ");

        return uniqueVendors;
    };

    renderOrders = (row: IAccounting) => {
        return <AccountingOrdersCol row={row} />;
    };

    renderDate = (row: IAccounting) => {
        return <div>{UserService.parseDate(row.created_at)}</div>;
    };

    viewQBOInvoice = (row: IAccounting) => {
        if (row) {
            const payload: IQBOGetPDFInvoiceDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                accountingGuid: row.guid,
            };

            this.props.socket.emit(EndpointsEnum.QBOGetPDFInvoice, payload);

            this.setState({
                createQboInvoiceActive: true,
            });
        }
    };

    onGetQboPdfInvoice = (data: IQBOOnGetPDFInvoiceDTO) => {
        const sideBarComponent = (
            <PdfSidebarViewer
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                file={data.data}
                cancel={this.cancelSidebar}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                qboInvoiceId={""}
                qboEntityId={""}
                orderGuid={""}
                qboInvoiceTotal={0}
                vendorEmail={""}
                qboVendorEmail={"-"}
                vendorGuid={""}
            />
        );

        this.props.setSidebarComponent(sideBarComponent);
        this.props.toggleSidebar(true);

        this.setState({
            createQboInvoiceActive: false,
        });
    };

    deleteQBOInvoice = (row: IAccounting) => {
        if (row) {
            const payload: IQBODeleteInvoiceDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                qbo_EntityId: row.qbo_invoice_id!,
            };

            this.props.socket.emit(EndpointsEnum.QBODeleteInvoice, payload);
        }
    };

    voidQBOInvoice = (row: IAccounting) => {};

    renderActionButtons = (row: IAccounting) => {
        return (
            <div>
                <OwButton
                    leftIconClass={"fad fa-download"}
                    title={"excel_breakdown"}
                    fn={() => {
                        this.downloadExcel(row);
                    }}
                />
                <AccountingActionsCol row={row} downloadJson={this.downloadJson} />
                {row.qbo_invoice_id ? (
                    <div className={"mt-2"}>
                        <QBOInvoiceActions
                            active={this.state.createQboInvoiceActive}
                            disabled={this.state.createQboInvoiceActive}
                            viewFn={this.viewQBOInvoice}
                            deleteFn={this.deleteQBOInvoice}
                            voidFn={this.voidQBOInvoice}
                            fieldsetClassName={"w-auto"}
                            data={row}
                        />
                    </div>
                ) : null}
            </div>
        );
    };

    buildQueryString = () => {
        const queryString: string[] = [];

        if (!_.isNil(this.state.name) && this.state.name.length) {
            queryString.push(`name=${this.state.name}`);
        }

        return "?" + queryString.join("&");
    };

    getAccounting = () => {
        const payload: IGetAccountingDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            offset: this.state.offset,
            limit: this.state.limit,
        };

        const queryString = this.buildQueryString();

        if (queryString.length) {
            payload.queryString = queryString;
        }

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit(EndpointsEnum.AccountingGetAccounting, payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onGetAccounting = (data: IOnGetAccountingDTO) => {
        this.setState(
            {
                isDataFetching: false,
                isInitialData: false,
                accountingRows: data.rows,
                totalRows: data.totalRows,
            },
            () => {
                const checkBoxChecked = _.map(this.state.accountingRows, (row: IAccounting) => {
                    return {
                        checked: false,
                        accountingGuid: row.guid,
                        name: row.name!,
                        qbd_TxnID: row.qbd_Invoice_TxnID,
                        accounting: row,
                    } as ICheckBoxCheckedAccounting;
                });

                this.setState({
                    checkBoxChecked,
                });
            }
        );
    };

    paginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                limit,
                offset,
            },
            () => {
                this.getAccounting();
            }
        );
    };

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const updatedState: any = {
            [name]: value,
        };

        this.setState(updatedState);
    };

    reset = () => {
        this.setState(
            {
                name: "",
            },
            () => {
                this.getAccounting();
            }
        );
    };

    render() {
        return (
            <div className={"Accounting"}>
                <div className="row">
                    <OwTitle className={"col-12"} title={"accounting"} leftIconName={"fad fa-abacus"} />
                </div>

                <div className="my-2">
                    <SearchSection>
                        <div className="d-flex align-items-end">
                            <div className={"w-15r"}>
                                <div>
                                    <OwLabel title={"name"} />
                                </div>
                                <OwFnInput fn={this.handleChange} name={"name"} value={this.state.name} />
                            </div>
                            <div className={"ms-4"}>
                                <OwButton title={"search"} fn={this.getAccounting} className={"btn-primary me-2"} />
                                <OwButton title={"reset"} fn={this.reset} className={"btn-danger"} />
                            </div>
                        </div>
                    </SearchSection>
                </div>

                <div className={"row"}>
                    <div className={"col-12"}>
                        <OwActionBar
                            toggleSmallTable={() => {}}
                            colToggledFn={() => {}}
                            columns={{}}
                            hideColumnToggle={true}
                            actions={this.state.actions}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <OwTable
                            columns={this.state.columns}
                            dataSet={this.state.accountingRows}
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            dataFetch={this.state.isDataFetching}
                            initialData={this.state.isInitialData}
                            checkAllFn={this.checkAll}
                        />
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-12"}>
                        <PaginationBar
                            offset={this.state.offset}
                            limit={this.state.limit}
                            totalRecords={this.state.totalRows}
                            onPaginationChanged={this.paginationChanged}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
